module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comments-and-logs"
  }, [_c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progressCommentsAndLogs),
      expression: "progressCommentsAndLogs"
    }],
    staticClass: "comments"
  }, [_c('md-dialog', {
    attrs: {
      "md-active": _vm.deleteDialog,
      "md-theme": "white"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.deleteDialog = $event
      }
    }
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.removeMessage))]), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": _vm.deleteComment
    }
  }, [_vm._v("Удалить")]), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.commentIdToDelete = null
      }
    }
  }, [_vm._v("Отмена")])], 1)], 1), _c('md-field', {
    staticClass: "comment-field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$props.placeholder))]), _c('md-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "edit-comment",
    attrs: {
      "disabled": _vm.sending,
      "name": "new_comment"
    },
    on: {
      "focus": function($event) {
        _vm.showCommentButton = true
      },
      "blur": _vm.hideCommentButton
    },
    model: {
      value: (_vm.comment.text),
      callback: function($$v) {
        _vm.$set(_vm.comment, "text", $$v)
      },
      expression: "comment.text"
    }
  })], 1), _c('div', {
    staticClass: "buttons"
  }, [(this.feed && this.feed.length && !_vm.$props.only_comments) ? _c('z-button', {
    attrs: {
      "light": "light"
    },
    on: {
      "click": _vm.toggleDetails
    }
  }, [_vm._v(_vm._s((_vm.showDetails) ? 'Скрыть подробности' : 'Показать подробности'))]) : _vm._e(), _c('z-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCommentButton),
      expression: "showCommentButton"
    }],
    attrs: {
      "light": "light"
    },
    on: {
      "click": function($event) {
        _vm.saveComment(_vm.comment)
      }
    }
  }, [_vm._v("Отправить")])], 1), (Object.keys(_vm.feed).length) ? _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.feed), function(item) {
    return ((item.type == 'log' && _vm.showDetails) || item.type == 'comment') ? _c('div', {
      key: item.id,
      staticClass: "item",
      class: {
        'visible': ((item.type == 'log' && _vm.showDetails) || item.type == 'comment')
      }
    }, [(item.type == 'comment') ? _c('div', {
      staticClass: "comment"
    }, [_c('div', {
      staticClass: "head"
    }, [(item.user) ? _c('div', {
      staticClass: "user"
    }, [_vm._v(_vm._s(item.user.login))]) : _c('div', {
      staticClass: "user"
    }, [_vm._v("Клиент")])]), _c('div', {
      staticClass: "body"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.edit != 1 && _vm.$store.state.users.current.id == item.user_id),
        expression: "item.edit != 1 && $store.state.users.current.id == item.user_id"
      }],
      staticClass: "md-layout-item md-layout md-alignment-top-right actions"
    }, [_c('md-button', {
      staticClass: "small md-dense md-icon-button edit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.editComment(item)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1), _c('md-button', {
      staticClass: "small md-dense md-icon-button edit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.showDeleteDialog(item.id)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1)], 1), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.edit != 1),
        expression: "item.edit != 1"
      }],
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      },
      on: {
        "click": function($event) {
          _vm.editComment(item)
        }
      }
    }, [_vm._v(_vm._s(item.text))]), _c('md-field', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.edit === 1),
        expression: "item.edit === 1"
      }],
      class: {
        'md-invalid': _vm.errors.has('edit_comment')
      }
    }, [_c('label', [_vm._v("Комментарий")]), _c('md-textarea', {
      attrs: {
        "id": "edit-comment",
        "disabled": _vm.sending,
        "name": "edit_comment",
        "id": 'comment-' + item.id
      },
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    }), _c('md-button', {
      staticClass: "md-dense md-icon-button",
      on: {
        "click": function($event) {
          _vm.saveComment(item)
        }
      }
    }, [_c('md-icon', [_vm._v("done")])], 1), _c('md-button', {
      staticClass: "md-dense md-icon-button md-warn",
      on: {
        "click": function($event) {
          item.edit = 0;
          item.text = item.oldText;
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1)], 1), (item.created_at) ? _c('div', {
      staticClass: "footer"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.moment.tz(item.created_at, _vm.$root.defaultTimezone).fromNow() + ' (' + _vm.moment(item.created_at).tz(_vm.$root.userTimezone).format('HH:mm DD.MM.YYYY') + ')'))])]) : _vm._e()]) : _vm._e(), (item.type == 'log') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDetails),
        expression: "showDetails"
      }],
      staticClass: "logs"
    }, [_c('div', {
      staticClass: "log"
    }, [(item.description) ? _c('div', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    })]) : _vm._e(), (item.created_at) ? _c('div', {
      staticClass: "footer"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.moment.tz(item.created_at, _vm.$root.defaultTimezone).fromNow() + ' (' + _vm.moment(item.created_at).tz(_vm.$root.userTimezone).format('HH:mm:ss DD.MM.YYYY') + ')'))])]) : _vm._e()])]) : _vm._e()]) : _vm._e()
  })) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31969440","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommentsAndLogs.vue
// module id = 1101
// module chunks = 0